// extracted by mini-css-extract-plugin
module.exports = {"notes":"BasicDetailsCard_notes__1GrSo","notesText":"BasicDetailsCard_notesText__13h9w"};